import {
  Driver_Read,
  getV1CompaniesCompanyIdDrivers,
  GetV1CompaniesCompanyIdDriversData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { DriverTypeahead } from '~hooks/useDrivers/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Driver_Read,
  DriverTypeahead,
  GetV1CompaniesCompanyIdDriversData
> & {
  companyId: string;
  shared?: boolean;
};

export default function AutocompleteDrivers<T extends FieldValues>({
  companyId,
  isDisabled,
  shared,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteDrivers"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId },
          query: {
            ...(shared !== undefined && { 'filter[shared]': shared }),
          },
        },
        request: getV1CompaniesCompanyIdDrivers,
      }}
      parseFn={(item: Driver_Read) => {
        const parsed = DriverTypeahead.parse(item);

        return { _entity: parsed, label: parsed.fullName, value: parsed.id };
      }}
    />
  );
}
